import { render, staticRenderFns } from "./location.vue?vue&type=template&id=02fafdf4&scoped=true"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fafdf4",
  null
  
)

export default component.exports